/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
// import axiosInstance from '../../utils/axiosInstance';
// import axiosInstance from 'axiosInstance';
import { axiosInstance } from "../../utils/axiosInstance"


const url = process.env.BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveHotels: [],
  hotelCityList: [],
  hotelList: [],
  hotelDetail: [],
  hotelBookingResponse: [],
  searchActivityRes: undefined,
  checkTimeRes: undefined,
  checkTimeResForPricing: undefined,
  activeIndex: 0,
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET SAVEHOTELS
    getCityListSuccess(state, action) {
      state.isLoading = false;
      state.cityListRes = action.payload;
    },
    getActivityListSuccess(state, action) {
      state.isLoading = false;
      state.activityListRes = action.payload;
    },
    getActivityListForPaginationSuccess(state, action) {
      state.isLoading = false;
      state.activityListForPaginationRes = action.payload;
    },
    getActivityDetailsSuccess(state, action) {
      state.isLoading = false;
      state.activityDetailsRes = action.payload;
    },
    getBookingSuccess(state, action) {
      state.isLoading = false;
      state.bookingRes = action.payload;
    },
    getSearchActivitySuccess(state, action) {
      state.isLoading = false;
      state.searchActivityRes = action.payload;
    },
    getSearchActivityListSuccess(state, action) {
      state.isLoading = false;
      state.searchActivityListRes = action.payload;
    },
    getSearchActivityFilterSuccess(state, action) {
      state.isLoading = false;
      state.searchActivityFilterRes = action.payload;
    },
    getSearchActivityFilterCurrency(state, action) {
      state.isLoading = false;
      state.searchActivityFilterCurrency = action.payload;
    },
    getCheckTimeSlot(state, action) {
      state.isLoading = false;
      state.checkTimeRes = action.payload;
    },
    getCheckTimeSlotForPricing(state, action) {
      state.isLoading = false;
      state.checkTimeResForPricing = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function carouselReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ACTIVE_INDEX':
      return { ...state, activeIndex: action.payload }
    default:
      return state
  }
}

export function getCityList(obj) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/searchCity`, obj);
      dispatch(slice.actions.getCityListSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function activityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/listActivities`, obj);
      dispatch(slice.actions.getActivityListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getActivityListSuccess(error));

      dispatch(slice.actions.hasError(error));
    }
  };
}


export function activityListForPagination(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/listActivities`, obj);
      dispatch(slice.actions.getActivityListForPaginationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getActivityListForPaginationSuccess(error));

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function activityDetails(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/activityDetail`, obj);
      dispatch(
        slice.actions.getActivityDetailsSuccess(response.data.activityDetails)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function booking(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/booking/activities`, obj);
      dispatch(slice.actions.getBookingSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function searchActivity(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/searchActivity`, obj);
      dispatch(slice.actions.getSearchActivitySuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchActivityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/searchList`, obj);
      dispatch(
        slice.actions.getSearchActivityListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchActivityFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/filterLists`, obj);
      dispatch(
        slice.actions.getSearchActivityFilterSuccess(response.data.responseData),
        slice.actions.getSearchActivityFilterCurrency(response.data)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function checkTime(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/checkTime`, obj);
      dispatch(
        slice.actions.getCheckTimeSlot(response.data),
        slice.actions.getCheckTimeSlot(response.data)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function checkTimeForPricing(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/checkTime`, obj);
      dispatch(
        slice.actions.getCheckTimeSlotForPricing(response.data),
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
